import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import { GlobalStyles as DefaultStyles } from "twin.macro";
import App from "./App";

const GlobalStyles = createGlobalStyle`
	html {
		font-family: 'Roboto', sans-serif;
		font-size: clamp(24px, calc(10px + 2vw), 40px);
	}

	*[disabled], *[aria-disabled] {
		opacity: 0.5;
	}

	:root {
		--gap-x-global: max(2.5%, 1vw);
		--hr-border: 1px solid #b1b1b177;
		--nav-h: 2rem;
		--content-h: calc(100vh - var(--nav-h));
	}
`;

export const root = ReactDOM.createRoot(
  document.querySelector("#root") as HTMLDivElement
);



root.render(
  // <StrictMode>
    <BrowserRouter>
      <DefaultStyles />
      <GlobalStyles />
      <App />
    </BrowserRouter>
  // </StrictMode>
);
